import styled from 'styled-components'
import { BaseButton } from 'app/components/common/BaseButton'
import { media } from 'parkway-web-common'
import { BaseDivider } from 'app/components/common/BaseDivider'
import { BaseTypography } from 'app/components/common/BaseTypography'

export const NoticesOverlayMenu = styled.div`
  width: 400px;

  ::-webkit-scrollbar {
    width: 0px !important;
  }

  padding-bottom: 16px;

  .ant-tabs-nav {
    padding-left: 16px;
  }

  @media only screen and ${media.md} {
    width: 600px;
  }
`

export const SplitDivider = styled(BaseDivider)`
  margin: 0 0.5rem;
`

export const LinkBtn = styled(BaseButton)`
  &.ant-btn {
    padding: 0;
    font-size: 0.875rem;
    height: unset;
    line-height: unset;
  }
`

export const Btn = styled(BaseButton)`
  width: 100%;
`

export const Text = styled(BaseTypography.Text)`
  display: block;
  text-align: center;
`
